import React, { useState } from "react";
import cn from "classnames";
import styles from "./ImagesAndCTA.module.sass";
import Card from "../../../components/Card";
import File from "../../../components/File";
import TextInput from "../../../components/TextInput";
import Icon from "../../../components/Icon";
import { toast } from "react-toastify";

const ConventionInformations = ({ className, formation, onFormationChange, onDropdownChange, loading, visible = true, onSubmit }) => {
  const [uploadedDocument, setUploadedDocument] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  
  
  if (!visible) return null;

  // Fonction pour gérer l'upload du document
  const handleFileUpload = async (file) => {
    if (!file) return;
    
    console.log('Fichier sélectionné:', file.name);
    
    try {
      setUploadLoading(true);
      
      // Simuler un délai d'upload pour voir le loading
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Créer un objet document simulé (à adapter selon votre logique)
      const documentData = {
        id: Date.now(), // ID temporaire
        file: file.name,
        title: file.name,
        type: "Convention",
        created: new Date().toISOString(),
        size: file.size,
        fileObject: file // Garder le fichier pour un traitement ultérieur
      };
      
      console.log('Document créé:', documentData);
      setUploadedDocument(documentData);
      
      // Mettre à jour les données de formation avec le fichier
      if (onFormationChange) {
        onFormationChange({
          target: {
            name: 'convention_file',
            value: file
          }
        });
        console.log('Fichier ajouté aux données de formation:', file.name);
      }
      
      toast.success('Document importé avec succès');
    } catch (error) {
      console.error('Erreur lors de l\'upload:', error);
      toast.error('Erreur lors de l\'import du document');
    } finally {
      setUploadLoading(false);
    }
  };

  // Fonction pour supprimer le document
  const handleDeleteDocument = () => {
    setUploadedDocument(null);
    
    // Supprimer le fichier des données de formation
    if (onFormationChange) {
      onFormationChange({
        target: {
          name: 'convention_file',
          value: null
        }
      });
    }
    
    toast.success('Document supprimé avec succès');
  };


  return (
    <Card
      className={cn(styles.card, className)}
      title="Convention de formation"
      classTitle="title-blue"
    >
      <div className={styles.images}>
        {uploadLoading ? (
          <div className={styles.loadingState}>
            <div className={styles.loadingContent}>
              <div className={styles.spinner}></div>
              <p>Import du document en cours...</p>
            </div>
          </div>
        ) : !uploadedDocument ? (
          <File
            className={styles.field}
            title="Glissez-déposez ou cliquez pour importer la convention"
            label="Convention de formation"
            tooltip="Formats acceptés: PDF, DOC, DOCX"
            onChange={handleFileUpload}
            accept=".pdf,.doc,.docx"
          />
        ) : (
          <div className={styles.uploadedDocument}>
            <div className={styles.documentHeader}>
              <h4>Document importé</h4>
            </div>
            <div className={styles.documentItem}>
              <div className={styles.preview}>
                <img src={'/images/content/contract_logo.png'} alt="Document" />
              </div>
              <div className={styles.documentInfo}>
                <div className={styles.title}>
                  {uploadedDocument.title.length > 30 
                    ? uploadedDocument.title.substring(0, 30) + '...' 
                    : uploadedDocument.title}
                </div>
                <div className={styles.details}>
                  {uploadedDocument.type} - Importé le {new Date(uploadedDocument.created).toLocaleDateString('fr-FR')}
                </div>
              </div>
              <button 
                className={styles.deleteButton}
                onClick={handleDeleteDocument}
                title="Supprimer le document"
              >
                <Icon name="close" size="16" />
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={styles.divider}></div>

      {/* Bouton de soumission */}
      <div className={styles.actions}>
        <button
          className={cn("button", styles.button)}
          type="submit"
          disabled={loading}
        >
          {loading ? "Enregistrement en cours..." : "Enregistrer les modifications"}
        </button>
      </div>
    </Card>
  );
};

export default ConventionInformations;
